import isolated from "./webext/isolated-full.mjs";
import main from "./webext/main.mjs";

export {isolated, main};
export {main as injected};
